import { Skeleton } from "@heroui/skeleton";

export default function ListingCardSkeleton() {
  return (
    <article
      aria-busy="true"
      aria-label="Chargement d'une annonce"
      className="editorial-surface flex h-full min-w-0 flex-col overflow-hidden rounded-2xl motion-safe:animate-pulse motion-reduce:opacity-70"
    >
      {/* Image placeholder — 16:10 */}
      <div className="relative aspect-[16/10] w-full overflow-hidden">
        <Skeleton className="h-full w-full rounded-none" />
      </div>

      {/* Body placeholder */}
      <div className="flex flex-1 flex-col gap-3 p-4">
        <div className="space-y-1">
          <Skeleton className="h-3 w-20 rounded-full" />
          <Skeleton className="h-5 w-3/4 rounded-md" />
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <Skeleton className="h-4 w-24 rounded-md" />
          <Skeleton className="h-4 w-16 rounded-md" />
        </div>
        <Skeleton className="h-3.5 w-28 rounded-md" />
        <Skeleton className="h-3 w-full rounded-md" />
        <Skeleton className="h-3 w-5/6 rounded-md" />
        <div className="flex-1" />
        <div className="flex items-end justify-between gap-2 border-t border-default-200/30 pt-3">
          <div className="space-y-1">
            <Skeleton className="h-2.5 w-14 rounded-full" />
            <Skeleton className="h-6 w-16 rounded-md" />
          </div>
          <Skeleton className="h-9 w-28 rounded-full" />
        </div>
      </div>
    </article>
  );
}
